// extracted by mini-css-extract-plugin
module.exports = {"dp-BusinessPopup--header":"dp-BusinessPopup--header___2-JQv"};